import { OpenFinanceVersion, useGetConsentsBanksQuery } from '../services/openFinanceApi';
import { ConsentPartner } from '../services/types';
export const useConsentBanks = (partyId, options) => {
    const resultV1 = useGetConsentsBanksQuery({ partyId, version: OpenFinanceVersion.V1 }, {
        skip: options?.skip || options?.onlyPluggy,
        pollingInterval: options?.pollingInterval,
        refetchOnMountOrArgChange: options?.refetchOnMountOrArgChange,
        refetchOnFocus: options?.refetchOnFocus,
        refetchOnReconnect: options?.refetchOnReconnect,
    });
    const resultV2 = useGetConsentsBanksQuery({ partyId, version: OpenFinanceVersion.V2 }, {
        skip: options?.skip,
        pollingInterval: options?.pollingInterval,
        refetchOnMountOrArgChange: options?.refetchOnMountOrArgChange,
        refetchOnFocus: options?.refetchOnFocus,
        refetchOnReconnect: options?.refetchOnReconnect,
    });
    const consentBanksV1 = resultV1.data?.result?.map(item => ({
        ...item,
    }));
    const consentBanksV2 = resultV2.data?.result?.map(item => ({
        ...item,
    }));
    const refetch = () => {
        resultV1.refetch();
        resultV2.refetch();
    };
    let consentBanks = [...(consentBanksV1 || []), ...(consentBanksV2 || [])];
    if (options?.groupByBank) {
        consentBanks = groupConsentBanks(consentBanks);
    }
    return {
        consentBanks,
        isLoading: resultV1.isLoading || resultV2.isLoading,
        error: resultV1.error || resultV2.error,
        refetch,
    };
};
const groupConsentBanks = (consentBanks) => {
    const grouped = consentBanks.reduce((acc, item) => {
        const key = item.externalBankCode;
        if (!acc[key]) {
            acc[key] = [item];
        }
        else if (acc[key] && item.partner === ConsentPartner.PLUGGY) {
            let balance = acc[key].reduce((acc, item) => acc + (item.balance ?? 0), 0);
            balance += item.balance ?? 0;
            acc[key] = [{ ...item, balance }];
        }
        return acc;
    }, {});
    return Object.values(grouped).flat();
};
